var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.page.toUpperCase()))]),_c('el-divider'),_c('div',{attrs:{"id":"area"},domProps:{"innerHTML":_vm._s(_vm.data)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }